import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useSelector } from "react-redux";
import { Check, PdClose } from "src/components/Icons";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kStyleConst } from "src/kStyle";

const Ribbon: React.FC = () => {
  const dispatch = useAppDispatch();
  const showRibbon = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.showRibbon);
  const message = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.message);
  const status = useSelector(({ ErrorHandlerReducer }) => ErrorHandlerReducer.errorType);
  const isSuccess = status === "SUCCESS";

  React.useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (showRibbon) {
      timeout = setTimeout(() => dispatch({ type: "RIBBON" }), 7000);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [dispatch, showRibbon]);

  const handleOnPressDelete = () => {
    if (showRibbon) {
      dispatch({ type: "RIBBON" });
    }
  };

  if (!showRibbon) {
    return null;
  }

  const IconComp = isSuccess ? Check : PdClose;

  return (
    <View style={[styles.toast, isSuccess ? styles.bgGreen200 : styles.bgYellow200]}>
      <TouchableOpacity onPress={handleOnPressDelete} style={styles.toastCloseButton}>
        <PdClose style={styles.toastCloseButtonIcon} color={kColors.brandDark} />
      </TouchableOpacity>
      <View>
        <IconComp style={[styles.toastIcon, styles.mr2, styles.mt2]} color={kColors.brandDark} />
      </View>
      <Text numberOfLines={3} style={[styles.toastLabel, styles.mr3]}>
        {typeof message === "string" ? message : ""}
      </Text>
    </View>
  );
};

const ToastProvider: React.FC = ({ children }) => {
  return (
    <>
      {children}
      <Ribbon />
    </>
  );
};

export default ToastProvider;

const styles = StyleSheet.create({
  bgGreen200: {
    backgroundColor: kColors.green200,
  },
  bgYellow200: {
    backgroundColor: kColors.yellow200,
  },
  mr2: {
    marginRight: 2 * kStyleConst.kSpacing,
  },
  mr3: {
    marginRight: 3 * kStyleConst.kSpacing,
  },
  mt2: {
    marginTop: 1 * kStyleConst.kSpacing,
  },
  toast: {
    bottom: 30,
    flexDirection: "row",
    maxWidth: 300,
    paddingHorizontal: 2 * kStyleConst.kSpacing,
    paddingVertical: kStyleConst.kSpacing,
    position: "absolute",
    right: 50,
    shadowColor: kColors.black,
    shadowOffset: { width: 5, height: 10 },
    shadowOpacity: 0.1,
    shadowRadius: 30,
    zIndex: 151,
  },
  toastCloseButton: {
    padding: 2 * kStyleConst.kSpacing,
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10,
  },
  toastCloseButtonIcon: {
    height: 7,
    width: 7,
  },
  toastIcon: {
    height: 10,
    width: 10,
  },
  toastLabel: {
    color: kColors.brandDark,
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: "400",
    letterSpacing: 1,
  },
});
